import { render, staticRenderFns } from "./manage-make.vue?vue&type=template&id=90d647e6&scoped=true&"
import script from "./manage-make.vue?vue&type=script&lang=js&"
export * from "./manage-make.vue?vue&type=script&lang=js&"
import style0 from "./manage-make.vue?vue&type=style&index=0&id=90d647e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d647e6",
  null
  
)

export default component.exports